import React, { useEffect, useState } from "react";
import api from "../../utils/axios.config";
import { baseUrl } from "../../utils/url";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { HandHeart, Loader2 } from "lucide-react";

const ActivitiesSummary = () => {
  const [helps, setHelps] = useState([]);
  const [loading, setLoading] = useState(true);

  const handleGetHelps = async () => {
    try {
      setLoading(true);
      const { data } = await api.get("provide-help");
      setHelps(data.help);
    } catch (error) {
      console.error("Error fetching help activities:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleGetHelps();
  }, []);

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    <div className="py-16 px-4 max-w-7xl mx-auto">
      {/* Header with decorative elements */}
      <div className="text-center mb-10">
        <h1 className="relative inline-block text-3xl md:text-4xl font-bold text-primary mb-2">
          <span className="absolute -left-8 top-1/2 transform -translate-y-1/2 hidden md:block">
            <HandHeart className="h-6 w-6 text-primary/70" />
          </span>
          সহযোগিতা প্রদান
          <span className="absolute -right-8 top-1/2 transform -translate-y-1/2 hidden md:block">
            <HandHeart className="h-6 w-6 text-primary/70" />
          </span>
        </h1>
        <div className="h-1 w-24 bg-primary mx-auto rounded-full mb-4"></div>
        <p className="text-gray-600 max-w-2xl mx-auto">
          আমাদের অনুষ্ঠিত বিভিন্ন সহযোগিতা কার্যক্রম
        </p>
      </div>

      {loading ? (
        <div className="flex justify-center items-center h-64">
          <Loader2 className="h-12 w-12 text-primary animate-spin" />
        </div>
      ) : (
        <Carousel
          swipeable={true}
          draggable={true}
          showDots={true}
          responsive={responsive}
          autoPlay={true}
          ssr={true}
          infinite={true}
          autoPlaySpeed={3000}
          keyBoardControl={true}
          customTransition="all 500ms ease"
          transitionDuration={500}
          containerClass="carousel-container"
          removeArrowOnDeviceType={["tablet", "mobile"]}
          dotListClass="custom-dot-list-style"
          itemClass="carousel-item-padding-40-px"
        >
          {helps?.map((help) => (
            <div key={help._id} className="p-4">
              <div
                className="bg-white rounded-lg shadow-lg overflow-hidden transition-all duration-300 hover:shadow-xl hover:translate-y-[-5px] border border-gray-100 h-full"
                data-aos="fade-up"
                style={{ height: "400px" }} // Set a fixed height for the card
              >
                <div className="bg-primary/10 p-6 flex justify-center items-center">
                  <div className="w-32 h-32 rounded-full overflow-hidden border-4 border-white shadow-md">
                    <img
                      src={`${baseUrl}${help.imageUrl}`}
                      alt={help.title}
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>

                <div className="p-6 text-center flex flex-col justify-between h-full">
                  <div>
                    <h2 className="font-bold text-xl text-gray-800 mb-3">
                      {help?.title}
                    </h2>
                    <p className="text-gray-600">{help?.helpDetails}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Carousel>
      )}
    </div>
  );
};

export default ActivitiesSummary;
